<template>
  <div id="app" ref="box">
    <router-view />
  </div>
</template>
<script>

export default {
  name: "Home",
};
</script>
<style>
#app {
  font-family: Microsoft YaHei;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: auto; /*点击路由成功，但返回后页面无法滚动*/
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.contair {
  overflow: hidden;
  background-color: #f7f7f7;
}
</style>
